import React, { useEffect, useState } from "react";
import {Container,Grid} from '@material-ui/core';
import MemberCard from "../memberCard/card";
import { removeFirstObj } from "../../utils/common.utils";
// import translates from '../../translation.json';
// import { lang } from "../../config/app.config";
import { useParams } from "react-router";
import staff from "../../models/staff.model";
import { fetchStaffs } from "../../services/staff.service";
import Preloader from "../PreLoader";
// import {useSelector} from 'react-redux';
// import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';
interface params{
  dist_slug:string
}

const ElectionCommissioner:React.FC = ()=>{
  const {dist_slug} = useParams<params>();

  const [loading,setLoading] = useState<boolean>(false);
  const [commissioner,setEc] = useState<Array<staff>|undefined>(undefined);

  const fetchElectionerComission= async()=>{
    setLoading(true);
    const staffs =await fetchStaffs(dist_slug?dist_slug:'head-office','commissioner');
    setEc(staffs)
    setLoading(false);
  }

  useEffect(()=>{
    fetchElectionerComission();
  },[])// eslint-disable-line

  // const state = useSelector((state:{translation:TranslationState})=>state.translation);


  return(
    <>
    {loading?<Preloader/>:
    <>
    {commissioner && commissioner.length?
    <>
    <div>

      <Container maxWidth="lg">
        <div className="section-break-2">
          <Grid container className="" spacing={4}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <div className= "ec-wrapper" >
                  <MemberCard 
                    name={commissioner[0].name}
                    degisnation={commissioner[0].designation}
                    image={commissioner[0].image}
                    id={commissioner[0].id}
                  />
                </div>
            </Grid>

            <Grid item xs={12} md={12} lg={12} xl={12}>
              <Grid container spacing={4}>
              {
                removeFirstObj(commissioner).map((e:any,i:number)=>(
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={i} className="mb-05">
                  <div className= "ec-wrapper" >
                    <MemberCard 
                      sec={true}
                      name={e.name}
                      degisnation={e.designation}
                      image={e.image}
                      id={e.id}
                    />
                  </div>
                </Grid>
                ))
              }
              </Grid>
              
            </Grid>

          </Grid>
        </div>
      </Container>
    </div>
    </>
    :""}
    </>
    }
    </>
  );
}

export default ElectionCommissioner;